import { DragAndDrop } from "../../../../components/global/DragAndDrop";
import '../../../style.css'
import { motion } from "framer-motion";
import { animationDurationToShowQuestion } from "../../../../config";


export const TopPart = ({ state, topNumbers, bottomNumbers, timeduration, result, level }) => {
    const Fraction = ({ value }) => {
        const [num, den] = value.split('/');

        return (
            <div className="flex flex-col items-center leading-none text-purple-700">
                <div>{num}</div>
                <div className="w-full border-t-[2px] border-purple-700 my-[2px]" />
                <div>{den}</div>
            </div>
        );
    };
    return (
        <div
            className={`text-[32px] text-purple-700 flex overflow-hidden items-center w-full border-[3px] rounded-[16px] border-[#2F9EBA] bg-[#FFF] lg:rounded-[20px] 
                       ${state ? "lg:text-[40px] xl:w-[313px] xl:h-[150px] xl:text-[48px] md:text-[32px] toppartIsStateHeight" : "toppartIsNotStateHeight xl:text-[64px] md:text-[40px] md:text-[40px] lg:text-[48px]"}
                       text-[#FFF] font-bigfatScript justify-around
            `}
        >
            <div className={`flex justify-around items-center`}>
                <Fraction value={topNumbers[0]} />
            </div>
            <motion.div
                //animate={{y: [animate.shift() || 0, 0]}}
                transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
            >
                -
            </motion.div>
            <div className={`flex justify-around items-center`}>
                <Fraction value={bottomNumbers[0]} />
            </div>

            <motion.div
                //animate={{y: [animate.shift() || 0, 0]}}
                transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
            >
                =
            </motion.div>


            <DragAndDrop
                className={"addingresult"}
                isActive={result === "?" ? false : result}
            >
                <div
                    className={`adding
                    w-[100px]
                    xs:w-[120px]
                    md:w-[172px]
                    md:h-[58px]
                    lg:w-[209px]
                    lg:h-[73px]
                    xl:w-[271px]
                    xl:h-[96px]
                    h-[43px]
            rounded-[10px]
            flex
            items-center
            justify-center
            text-white
            ${result === "?" ? "bg-[#E4E4E4]" : "bg-[#85B054]"}
        `}
                >
                    {result === "?" ? "" : result}
                </div>
            </DragAndDrop>
        </div>
    )
}